import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./sidebar";
import Instruction from "./instruction";
import Program from "./program";
import PersonalInfo from "./personalinfo";
import AddressInfo from "./addressinfo";
import PhotoSignInfo from "./photosign";
import Education from "./education";
import CentrePage from "./centre";
import Declaration from "./declaration";
import Payment from "./payment";
import ApplicationReport from "./applicationreport";
import AdmitCard from "./admitcard";
import RankCard from './rankcard';
import RaiseComplaint from "./raisecomplaint";
import RaiseComplaintList from "./complaint_list";
import "./style.css";



function Dashboard() {

    const navigate = useNavigate();
    const [active, setActive] = useState("instruction");
    const [step, setStep] = useState(1);


    /*useEffect(() => {

        const token = sessionStorage.getItem("token");

        if (!token) {
            navigate("/Login", {
                replace: true,
                state: { message: "Please login to continue ❗" }
            });
        }

    }, [navigate]);*/

    useEffect(() => {

        const token = sessionStorage.getItem("token");

        if (!token || token === "null" || token === "undefined") {

            sessionStorage.clear();

            navigate("/Login", {
                replace: true,
                state: { message: "Please login to continue ❗" }
            });
        }

    }, [navigate]);



    const handleNext = () => {
        setStep(2);
        setActive("program");
    };

    //program tab 
    const handleProgramNext = () => {
        setStep(3);
        setActive("pi");
    };

    const handleProgramPrev = () => {
        setActive("instruction");
    };

    //personal info sub menu 1
    const handlePersonalInfoNext = () => {
        setStep(4);
        setActive("address");
    };

    const handlePersonalInfoPrev = () => {
        setActive("program");
    };

    //personal info sub menu 2
    const handleAddressInfoNext = () => {
        setStep(5);
        setActive("photo");
    };

    const handleAddressInfoPrev = () => {
        setActive("pi");
    };

    //personal info sub menu 3
    const handlePhotoSignNext = () => {
        setStep(6);
        setActive("education");
    };

    const handlePhotoSignPrev = () => {
        setActive("address");
    };

    //Education
    const handleEducationNext = () => {
        setStep(7);
        setActive("centre");
    };

    const handleEducationPrev = () => {
        setActive("photo");
    };

    //Centre
    const handleCentreNext = () => {
        setStep(8);
        setActive("declaration");
    };

    const handleCentrePrev = () => {
        setActive("education");
    };

    //Declaration
    const handleDeclarationNext = () => {
        setStep(9);
        setActive("payment");
    };

    const handleDeclarationPrev = () => {
        setActive("centre");
    };

    //Payment
    const handlePaymentNext = () => {
        setStep(10);
        setActive("report");
    };

    const handlePaymentPrev = () => {
        setActive("declaration");
    };

    //complain list
    const handleComplaintBoxNext = () => {
        setActive("complaintlist");
    }
    //
    const handleComplaintBoxListPrev = () => {
        setActive("complaintBox");
    }

    useEffect(() => {
        const handleBack = () => {
            window.history.pushState(null, "", window.location.href);
        };

        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", handleBack);

        return () => {
            window.removeEventListener("popstate", handleBack);
        };
    }, []);



    const renderContent = () => {
        switch (active) {
            case "instruction":
                return <Instruction onNext={handleNext} />;

            case "program":
                return (
                    <Program
                        onNext={handleProgramNext}
                        onPrev={handleProgramPrev}
                    />
                );

            case "pi":
                return (
                    <PersonalInfo
                        onNext={handlePersonalInfoNext}
                        onPrev={handlePersonalInfoPrev}
                    />
                );

            case "address":
                return (
                    <AddressInfo
                        onNext={handleAddressInfoNext}
                        onPrev={handleAddressInfoPrev}
                    />
                );

            case "photo":
                return (
                    <PhotoSignInfo
                        onNext={handlePhotoSignNext}
                        onPrev={handlePhotoSignPrev}
                    />
                );

            case "education":
                return (<Education
                    onNext={handleEducationNext}
                    onPrev={handleEducationPrev}
                />
                );

            case "centre":
                return (<CentrePage
                    onNext={handleCentreNext}
                    onPrev={handleCentrePrev}
                />);

            case "declaration":
                return (<Declaration
                    onNext={handleDeclarationNext}
                    onPrev={handleDeclarationPrev}
                />);

            case "payment":
                return (<Payment
                    onNext={handlePaymentNext}
                    onPrev={handlePaymentPrev}
                />);

            case "report":
                return <ApplicationReport />

            case "admitcard":
                return <AdmitCard />

            case "rankcard":
                return <RankCard />

            case "complaintBox":
                return (<RaiseComplaint
                    onNext={handleComplaintBoxNext}
                />);

            case "complaintlist":
                return (<RaiseComplaintList
                    onPrev={handleComplaintBoxListPrev}
                />);


            default:
                return <h2>Welcome</h2>;
        }
    };

    return (
        <div className="main-container">
            <Sidebar active={active} setActive={setActive} step={step} />
            <div className="content-area">
                {renderContent()}
            </div>
        </div>
    );
}

export default Dashboard;